// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1515":"043d9a18","1674":"3da27da5","9438":"98586ffe"}[chunkId] + ".chunk.css";
};